module.exports = __webpack_public_path__ + "static/media/tableList.bd83e307.svg";